module.exports = __webpack_public_path__ + "img/carpark.00ef9b8a.jpg";